var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UserDefinedCalcConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { Column, PeriodColumnMetadata } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { SpmCalcToolConfig } from './spmCalcToolConfig';
import { ToolCategories } from './toolCategories';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationState } from './validation/toolValidationResult';
const schema = {
    $id: 'urn:wisepipe-common-pipe:UserDefinedCalcConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            minItems: 1,
            maxItems: 1000
        },
        values: {
            type: 'array',
            items: { type: 'string', minLength: 1, maxLength: 150 },
            uniqueItems: true,
            minItems: 1,
            maxItems: 1000
        }
    },
    required: ['columns', 'values']
};
let UserDefinedCalcConfig = UserDefinedCalcConfig_1 = class UserDefinedCalcConfig extends SpmCalcToolConfig {
    constructor(columns, values, calendarID, start, end, customFormats) {
        super(calendarID, start, end, ToolType.USER_DEFINED_CALC, customFormats);
        this.columns = columns;
        this.values = values;
        JSON.validate(this, UserDefinedCalcConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    multiIns(inScope) {
        return [...inScope.names];
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return UserDefinedCalcConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get in0() {
        // for testing
        return `${UserDefinedCalcConfig_1.in}_0`;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return UserDefinedCalcConfig_1.out;
    }
    static get in() {
        return UserDefinedCalcConfig_1.ins[0];
    }
    static get out() {
        return UserDefinedCalcConfig_1.outs[0];
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return UserDefinedCalcConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return UserDefinedCalcConfig_1.outs;
    }
    static get ins() {
        return ['multi'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo('User Defined Calculation', [ToolCategories.CALCULATE], this.ins, this.outs, ['user defined', 'calculate', 'calculation', 'incentives'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        // JUST DO FIRST IN FOR NOW
        const source = ins.schemas.at(this.in0);
        if (source) {
            const exp = tsb.export(this.out);
            const dependents = [];
            this.columns.forEach((name) => {
                const col = source.find((s) => s.name === name);
                if (col) {
                    dependents.push(col);
                    if (col.type === 'date') {
                        exp.makeNew(new Column(name, 'period', new PeriodColumnMetadata(this.calendarID, '1')), dependents, true);
                    }
                    else {
                        exp.copy(this.in0, col, false, true);
                    }
                }
            });
            this.values.forEach((name) => {
                exp.makeNew(new Column(name, 'number'), dependents, true);
            });
            exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        }
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in0);
        if (!source) {
            return ToolValidationState.BAD_METADATA;
        }
        let calendarColumns = 0;
        const inputs = new Set(this.columns);
        const inputNames = new Set();
        for (const column of source) {
            if (!inputNames.has(column.name) && inputs.has(column.name)) {
                inputNames.add(column.name);
                if (column.type === 'date' || column.type === 'period') {
                    calendarColumns += 1;
                }
            }
        }
        if (calendarColumns > 1) {
            return ToolValidationState.BAD_METADATA;
        }
        else if (calendarColumns === 1 && this.calendarID === undefined) {
            return ToolValidationState.BAD_METADATA;
        }
        if (inputNames.size !== inputs.size) {
            return ToolValidationState.BAD_METADATA;
        }
        const outputs = this.columns.concat(this.values);
        return new Set(outputs).size === outputs.length ? ToolValidationState.VALID : ToolValidationState.BAD_METADATA;
    }
};
UserDefinedCalcConfig = UserDefinedCalcConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.USER_DEFINED_CALC)
], UserDefinedCalcConfig);
export { UserDefinedCalcConfig };
//# sourceMappingURL=userDefinedCalcConfig.js.map